// src/services/publicationService.js

import axios from "axios";


const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 30000, 
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json",
    "X-Requested-With": "XMLHttpRequest",
  },
});


export const getPublications = async ({
  type = null,
  page = 1,
  perPage = 10, 
  sortBy = "publication_date",
  sortOrder = "desc",
} = {}) => {
  try {
    const params = {
      page,
      per_page: perPage,
      sort_by: sortBy,
      sort_order: sortOrder,
    };

    if (type) {
      params.type = type;
    }

    
    const response = await api.get("", { params });

   
    if (!response.data) {
      throw new Error("Réponse API vide");
    }

    return {
      data: response.data.data || [],
      meta: response.data.meta || {},
      success: true
    };

  } catch (error) {
    console.error("Détails de l'erreur API:", error.response || error);

   
    if (error.response) {
      return {
        data: [],
        meta: {},
        success: false,
        error: error.response.data?.message || `Erreur serveur (${error.response.status})`,
      };
    }

    
    if (error.request) {
      return {
        data: [],
        meta: {},
        success: false,
        error: "Le serveur ne répond pas (vérifiez le CORS ou le Timeout)",
      };
    }

 
    return {
      data: [],
      meta: {},
      success: false,
      error: error.message,
    };
  }
};
